var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import SegundaVentana from '../components/segunda-ventana';
import { getConfigVentanas } from '../../selectors/config-ventanas';
import { getConfigLibro, getConsolaLupaDefecto, getConsolaLupaSegunAncho } from '../../selectors/config-libro';
import * as selectorsZona from '../../selectors/zona';
import { SEGUNDA_VENTANA_ID } from '../../constantes'; // const tipoVinculo = boton => boton.vinculo.split(',')[0]

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var configSegundaVentana = getConfigVentanas(state, SEGUNDA_VENTANA_ID) || {};
  var configLibro = getConfigLibro(state, ownProps.libroId);
  var configSegundaVentanaLibro = configLibro['segunda-ventana'] || {};

  var _flotante$escalable$a = _extends({
    flotante: true,
    escalable: true,
    ajusteInicial: 'contenido'
  }, configSegundaVentana, configSegundaVentanaLibro),
      flotante = _flotante$escalable$a.flotante,
      escalable = _flotante$escalable$a.escalable,
      ajusteInicial = _flotante$escalable$a.ajusteInicial; // extraer datos BOTON


  var boton = ownProps.boton;
  var contenido = selectorsZona.getContenidoBoton(state, boton);
  var consolaAudio = selectorsZona.getConsolaAudio(state, boton) || "";
  var lupaZona = selectorsZona.getConsolaLupa(state, boton);
  var lupaSegunAncho = contenido.libroId && contenido.coordenadasOriginales && getConsolaLupaSegunAncho(state, contenido.libroId, contenido.coordenadasOriginales, SEGUNDA_VENTANA_ID);
  var lupaLibro = getConsolaLupaDefecto(state, ownProps.libroId, SEGUNDA_VENTANA_ID);
  var lupaGlobal = configSegundaVentana.lupa;
  var consolaLupa = lupaZona || lupaSegunAncho || lupaLibro || lupaGlobal || "no,auto";
  var ajuste = selectorsZona.getAjuste(state, consolaLupa);
  var escala = selectorsZona.getEscala(state, consolaLupa);
  var botones = [{
    tipo: "titulo",
    id: boton.id
  }]; // TODO: construir un boton titulo a partir del id de la zona (ver pantallaProps para traer zona de primera ventana) y tipo= "titulo"

  if (window.modoTrabajo) {
    window.console.info("botón", ownProps.libroId, ownProps.numPagina, ownProps.numZona, boton.id);
    window.console.info("contenido", boton);
  }

  return {
    // ventana
    tieneAnimacion: true,
    configSegundaVentana: configSegundaVentana,
    flotante: flotante,
    escalable: escalable,
    // abierta,
    // botonera
    consolaAudio: consolaAudio,
    consolaLupa: consolaLupa,
    botones: botones,
    contenido: contenido,
    // comportamiento inicial de la ventana respecto al contenido
    // 'contenido' -> la ventana se ajusta al tam de la imagen, 
    // 'fijo' -> la ventana ocupa un 80% aprox de la pantalla
    ajusteInicial: ajusteInicial,
    //
    // contenido tipo zoom
    //
    // ajuste de la imagen al contendor
    // ancho | auto 
    ajuste: ajuste,
    // escala del contenedor con respecto a la ventana en %, por defecto 100
    escala: escala
  };
};

var SegundaVentanaContainer = connect(mapStateToProps, null)(SegundaVentana);
export default SegundaVentanaContainer;